<template>
	<div class="file-manager" v-bind:class="{'kaveh-loading':isLoading}" v-bind:style="{'min-height': fileManagerHeight}">

		<div class="row">
			<div class="col-12 col-lg-8">
				<div class="bg-gray2 rounded p-2">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb mb-0">
							<li class="breadcrumb-item cursor-pointer">
								<span @click="selectFolder(null)">
									<kaveh-icon-bootstrap name="bi-house" size="inherit" />
								</span>
							</li>
							<li class="breadcrumb-item cursor-pointer" v-for="(item,i) in breadcrumbs" :key="i">
								<span @click="selectFolder(item.virtualFolderId)">
									{{ item.title }}
								</span>
							</li>
						</ol>
					</nav>
				</div>
			</div>
			<div class="col-12 col-lg-4 text-end">
				<div class="bg-gray2 rounded p-1">
					<button class="btn btn-sm p-0 ms-2" @click="showVirtualFolderCreatePrompt">
						<kaveh-icon-bootstrap name="bi-folder-plus" size="17px" />
					</button>
					<button class="btn btn-sm p-0 ms-2" @click="showUploaderPopup">
						<kaveh-icon-bootstrap name="bi-file-plus" size="17px" />
					</button>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-12">
				<div class="row" v-if="folders.length > 0">
					<div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3 folder-wrapper" v-for="(item, index) in folders" :key="index">
						<div class="folder" :title="item.title" @click="selectFolder(item.virtualFolderId)">
							<div class="mb-2">
								<kaveh-icon-bootstrap name="bi-folder-fill" size="30px" color="#555" />
							</div>
							<small>{{ getShortTitle(item.title) }}</small>
						</div>
						<div class="folder-action">
							<div class="btn-group">
								<button type="button" class="btn p-0" data-bs-toggle="dropdown" aria-expanded="false">
									<kaveh-icon-bootstrap name="bi-three-dots-vertical" size="13px" />
								</button>
								<ul class="dropdown-menu dropdown-menu-end">
									<li class="cursor-pointer" @click="deleteFolder(item)">
										<div class="dropdown-item">
											<span class="me-2">
												<kaveh-icon-bootstrap name="bi-trash" color="red" size="13px" />
											</span>
											<span>
												{{$loc.fromResource('action.delete')}}
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="files.length > 0">
					<div class="col-6 col-md-4 col-lg-3 col-xl-2 mt-3 file-wrapper" v-for="(item, index) in files" :key="index">
						<div class="file" :title="item.fileName" @click="selectedFile = item">
							<div class="mb-2">
								<kaveh-icon-bootstrap :name="getFileIcon(item.contentType)" size="30px" color="#555" />
							</div>
							<small>{{ getShortTitle(item.fileName) }}</small>
						</div>
						<div class="file-action">
							<div class="btn-group">
								<button type="button" class="btn p-0" data-bs-toggle="dropdown" aria-expanded="false">
									<kaveh-icon-bootstrap name="bi-three-dots-vertical" size="13px" />
								</button>
								<ul class="dropdown-menu dropdown-menu-end">
									<li class="cursor-pointer" @click="deleteFile(item)">
										<div class="dropdown-item">
											<span class="me-2">
												<kaveh-icon-bootstrap name="bi-trash" color="red" size="13px" />
											</span>
											<span>
												{{$loc.fromResource('action.delete')}}
											</span>
										</div>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-if="folders.length == 0 && files.length == 0">
					<div class="col-12 text-center">
						<svg style="max-width:200px; max-height:270px;" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" width="782.04441" height="701.88002" viewBox="0 0 782.04441 701.88002" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M609.48783,100.59015l-25.44631,6.56209L270.53735,187.9987,245.091,194.56079A48.17927,48.17927,0,0,0,210.508,253.17865L320.849,681.05606a48.17924,48.17924,0,0,0,58.61776,34.58317l.06572-.01695,364.26536-93.93675.06572-.01695a48.17923,48.17923,0,0,0,34.58309-58.6178l-110.341-427.87741A48.17928,48.17928,0,0,0,609.48783,100.59015Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M612.94784,114.00532l-30.13945,7.77236L278.68955,200.20385l-30.139,7.77223a34.30949,34.30949,0,0,0-24.6275,41.74308l110.341,427.87741a34.30946,34.30946,0,0,0,41.7431,24.62736l.06572-.01695,364.26536-93.93674.06619-.01707a34.30935,34.30935,0,0,0,24.627-41.7429l-110.341-427.87741A34.30938,34.30938,0,0,0,612.94784,114.00532Z" transform="translate(-208.9778 -99.05999)" fill="#fff" /><path d="M590.19,252.56327,405.917,300.08359a8.01411,8.01411,0,0,1-4.00241-15.52046l184.273-47.52033A8.01412,8.01412,0,0,1,590.19,252.56327Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M628.955,270.49906,412.671,326.27437a8.01411,8.01411,0,1,1-4.00241-15.52046l216.284-55.77531a8.01411,8.01411,0,0,1,4.00242,15.52046Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M620.45825,369.93676l-184.273,47.52032a8.01411,8.01411,0,1,1-4.00242-15.52046l184.273-47.52032a8.01411,8.01411,0,1,1,4.00241,15.52046Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M659.22329,387.87255l-216.284,55.77531a8.01411,8.01411,0,1,1-4.00242-15.52046l216.284-55.77531a8.01411,8.01411,0,0,1,4.00242,15.52046Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M650.72653,487.31025l-184.273,47.52033a8.01412,8.01412,0,0,1-4.00242-15.52047l184.273-47.52032a8.01411,8.01411,0,0,1,4.00242,15.52046Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M689.49156,505.246l-216.284,55.77532a8.01412,8.01412,0,1,1-4.00241-15.52047l216.284-55.77531a8.01411,8.01411,0,0,1,4.00242,15.52046Z" transform="translate(-208.9778 -99.05999)" fill="#f2f2f2" /><path d="M374.45884,348.80871l-65.21246,16.817a3.847,3.847,0,0,1-4.68062-2.76146L289.5963,304.81607a3.847,3.847,0,0,1,2.76145-4.68061l65.21247-16.817a3.847,3.847,0,0,1,4.68061,2.76145l14.96947,58.04817A3.847,3.847,0,0,1,374.45884,348.80871Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M404.72712,466.1822l-65.21247,16.817a3.847,3.847,0,0,1-4.68062-2.76146l-14.96946-58.04816A3.847,3.847,0,0,1,322.626,417.509l65.21246-16.817a3.847,3.847,0,0,1,4.68062,2.76145l14.96946,58.04817A3.847,3.847,0,0,1,404.72712,466.1822Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M434.99539,583.55569l-65.21246,16.817a3.847,3.847,0,0,1-4.68062-2.76145l-14.96946-58.04817a3.847,3.847,0,0,1,2.76145-4.68062l65.21247-16.817a3.847,3.847,0,0,1,4.68061,2.76146l14.96947,58.04816A3.847,3.847,0,0,1,434.99539,583.55569Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M863.63647,209.0517H487.31811a48.17928,48.17928,0,0,0-48.125,48.12512V699.05261a48.17924,48.17924,0,0,0,48.125,48.12507H863.63647a48.17924,48.17924,0,0,0,48.125-48.12507V257.17682A48.17928,48.17928,0,0,0,863.63647,209.0517Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M863.637,222.90589H487.31811a34.30948,34.30948,0,0,0-34.271,34.27093V699.05261a34.30947,34.30947,0,0,0,34.271,34.27088H863.637a34.30936,34.30936,0,0,0,34.27051-34.27088V257.17682A34.30937,34.30937,0,0,0,863.637,222.90589Z" transform="translate(-208.9778 -99.05999)" fill="#fff" /><circle cx="694.19401" cy="614.02963" r="87.85039" fill="#dddddd" /><path d="M945.18722,701.63087H914.63056V671.07421a11.45875,11.45875,0,0,0-22.9175,0v30.55666H861.1564a11.45875,11.45875,0,0,0,0,22.9175h30.55666V755.105a11.45875,11.45875,0,1,0,22.9175,0V724.54837h30.55666a11.45875,11.45875,0,0,0,0-22.9175Z" transform="translate(-208.9778 -99.05999)" fill="#fff" /><path d="M807.00068,465.71551H616.699a8.01412,8.01412,0,1,1,0-16.02823H807.00068a8.01412,8.01412,0,0,1,0,16.02823Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M840.05889,492.76314H616.699a8.01412,8.01412,0,1,1,0-16.02823H840.05889a8.01411,8.01411,0,1,1,0,16.02823Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M807.00068,586.929H616.699a8.01412,8.01412,0,1,1,0-16.02823H807.00068a8.01411,8.01411,0,0,1,0,16.02823Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M840.05889,613.97661H616.699a8.01412,8.01412,0,1,1,0-16.02823H840.05889a8.01412,8.01412,0,1,1,0,16.02823Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M574.07028,505.04162H506.72434a3.847,3.847,0,0,1-3.84278-3.84278V441.25158a3.847,3.847,0,0,1,3.84278-3.84278h67.34594a3.847,3.847,0,0,1,3.84278,3.84278v59.94726A3.847,3.847,0,0,1,574.07028,505.04162Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M574.07028,626.25509H506.72434a3.847,3.847,0,0,1-3.84278-3.84278V562.46505a3.847,3.847,0,0,1,3.84278-3.84278h67.34594a3.847,3.847,0,0,1,3.84278,3.84278v59.94726A3.847,3.847,0,0,1,574.07028,626.25509Z" transform="translate(-208.9778 -99.05999)" fill="#e6e6e6" /><path d="M807.21185,330.781H666.91017a8.01411,8.01411,0,0,1,0-16.02823H807.21185a8.01411,8.01411,0,0,1,0,16.02823Z" transform="translate(-208.9778 -99.05999)" fill="#ccc" /><path d="M840.27007,357.82862H666.91017a8.01411,8.01411,0,1,1,0-16.02822h173.3599a8.01411,8.01411,0,0,1,0,16.02822Z" transform="translate(-208.9778 -99.05999)" fill="#ccc" /><path d="M635.85911,390.6071H506.51316a3.847,3.847,0,0,1-3.84277-3.84277V285.81706a3.847,3.847,0,0,1,3.84277-3.84277H635.85911a3.847,3.847,0,0,1,3.84277,3.84277V386.76433A3.847,3.847,0,0,1,635.85911,390.6071Z" transform="translate(-208.9778 -99.05999)" fill="#dddddd" /></svg>
					</div>
					<div class="col-12 text-center">
						<button class="btn btn-sm btn-light" @click="showVirtualFolderCreatePrompt">
							<kaveh-icon-bootstrap name="bi-folder-plus" />
							<span class="ms-2">{{$loc.fromResource('asset.ext.fileManager.createFolder')}}</span>
						</button>
						<button class="btn btn-sm btn-light" @click="showUploaderPopup">
							<kaveh-icon-bootstrap name="bi-file-plus" />
							<span class="ms-2">{{$loc.fromResource('asset.ext.fileManager.uploadFile')}}</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
	<kaveh-popup v-if="isShowUploaderPopup" width="800px" :close="() => {isShowUploaderPopup = false}">
		<kaveh-uploader @change="changeUploader" />
		<div class="mt-3" v-if="chosenFiles.length > 0">
			<div class="mb-3 bg-gray rounded border p-3">
				<label>{{$loc.fromResource('asset.ext.fileManager.accessTitle')}}</label>
				<select class="form-select" v-model="isPrivate">
					<option :value="true">{{$loc.fromResource('asset.ext.fileManager.accessPrivateTitle')}}</option>
					<option :value="false">{{$loc.fromResource('asset.ext.fileManager.accessPublicTitle')}}</option>
				</select>
			</div>
			<kaveh-button :is-loading="isLoadingUpload" class="btn btn-dark w-100" @click="upload">
				<kaveh-icon-bootstrap name="bi-cloud-arrow-up" />
				<span class="ms-2">{{$loc.fromResource('asset.ext.fileManager.uploadAction')}}</span>
			</kaveh-button>
		</div>
	</kaveh-popup>

	<kaveh-popup v-if="selectedFile" width="800px" :close="() => {selectedFile = null}">
		<div class="row g-0">
			<div class="col-12 text-center">
				<kaveh-icon-bootstrap :name="getFileIcon(selectedFile.contentType)" size="100px" color="#555" />
			</div>
			<table class="table table-backgroundless">
				<tbody>
					<tr>
						<th style="width:150px;">{{$loc.fromResource('asset.ext.fileManager.info.fileName')}}</th>
						<td>{{ selectedFile.fileName }}</td>
					</tr>
					<tr>
						<th>{{$loc.fromResource('asset.ext.fileManager.info.extensionName')}}</th>
						<td>{{ selectedFile.extensionName }}</td>
					</tr>
					<tr>
						<th>{{$loc.fromResource('asset.ext.fileManager.info.contentType')}}</th>
						<td>{{ selectedFile.contentType }}</td>
					</tr>
					<tr>
						<th>{{$loc.fromResource('asset.ext.fileManager.info.key')}}</th>
						<td>{{ selectedFile.systemName }}</td>
					</tr>
					<tr>
						<th>{{$loc.fromResource('asset.ext.fileManager.info.createDateTime')}}</th>
						<td>{{ selectedFile.createDate }} {{ selectedFile.createTime }}</td>
					</tr>
					<tr v-if="selectedFile.modifyDate ">
						<th>{{$loc.fromResource('asset.ext.fileManager.info.modifyDateTime')}}</th>
						<td>{{ selectedFile.modifyDate }} {{ selectedFile.modifyTime }}</td>
					</tr>

					<tr v-if="selectedFile.isPrivate == true">
						<th>{{$loc.fromResource('asset.ext.fileManager.info.download')}}</th>
						<td>
							<a class="text-success" rel="nofollow" :href="$assetPrivateLink(selectedFile.systemName, false, true)">
								<span>{{$loc.fromResource('asset.ext.fileManager.info.clickToDownload')}}</span>
							</a>
						</td>
					</tr>
					<tr v-if="selectedFile.isPrivate == true">
						<td colspan="2">
							<div class="p-2">
								<div class="mb-2">{{$loc.fromResource('asset.ext.fileManager.info.externalLink')}}</div>
								<div class="mb-2">
									<span>{{$loc.fromResource('asset.ext.fileManager.info.tokenWarning')}}</span>
								</div>
								<div dir="ltr">{{$assetPrivateLink(selectedFile.systemName, false, false)}}?access_token={token}</div>
							</div>
						</td>
					</tr>

					<tr v-if="selectedFile.isPrivate == false">
						<th>{{$loc.fromResource('asset.ext.fileManager.info.download')}}</th>
						<td>
							<a class="text-success" rel="nofollow" :href="$assetPublicLink(selectedFile.systemPath)">
								<span>{{$loc.fromResource('asset.ext.fileManager.info.clickToDownload')}}</span>
							</a>
						</td>
					</tr>
					<tr v-if="selectedFile.isPrivate == false">
						<td colspan="2">
							<div class="p-2">
								<div class="mb-2">{{$loc.fromResource('asset.ext.fileManager.info.externalLink')}}</div>
								<div dir="ltr">{{$assetPublicLink(selectedFile.systemPath)}}</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</kaveh-popup>
</template>
<style>
	.file-manager {
		width: 100%;
		background: #F8F9FA;
		border-radius: 10px;
		padding: 10px;
	}

		.file-manager .folder-wrapper,
		.file-manager .file-wrapper {
			position: relative;
		}

		.file-manager .folder,
		.file-manager .file {
			border-radius: 10px;
			border: #ddd solid 1px;
			height: 100px;
			padding: 10px;
			cursor: pointer;
			background: #f8f8f8;
			text-align: center;
		}

			.file-manager .folder:hover,
			.file-manager .file:hover {
				background: #f4f4f4;
			}

		.file-manager .folder-action,
		.file-manager .file-action {
			position: absolute;
			top: 3px;
			left: 15px;
		}
</style>
<script>
	import { fileExtensions } from '@/core/data/statics'
	import { VirtualFolderService, StaticFileService, FileExtensionService } from '@/modules/asset/services'
	export default {
		data()
		{
			return {
				isLoading: true,
				isLoadingUpload: false,
				isShowUploaderPopup: false,
				isShowVirtualFolderCreatePopup: false,

				files: [],
				selectedFile: null,
				VirtualFolders: [],
				chosenFiles: [],

				virtualFolderId: null,
				isPrivate: true,
			}
		},

		beforeMount()
		{
			this.init();
		},

		computed:
		{
			folders()
			{
				var result = [];

				for (var i = 0; i < this.VirtualFolders.length; i++)
				{
					const item =
						this.VirtualFolders[i];

					if (item.parentId == this.virtualFolderId)
					{
						result.push(item)
					}
				}

				return result;
			},

			breadcrumbs()
			{
				if (this.virtualFolderId == null || this.VirtualFolders.length == 0)
				{
					return [];
				}

				var result = [];
				var getFolderInfo = (virtualFolderId) =>
				{
					const index =
						this.VirtualFolders.findIndex((x) =>
						{
							return x.virtualFolderId == virtualFolderId
						})

					return this.VirtualFolders[index]
				}

				var virtualFolderId =
					this.virtualFolderId;

				do
				{
					const folder = getFolderInfo(virtualFolderId)
					virtualFolderId = folder.parentId;

					result.push(folder)

				} while (virtualFolderId != null);

				return result.reverse();
			},

			fileManagerHeight()
			{
				return `${(window.innerHeight - 200)}px`;
			}
		},

		methods:
		{
			async init()
			{
				this.isLoading = true;

				await this.initVirtualFolders();
				await this.initFiles();

				this.isLoading = false;
			},

			async showVirtualFolderCreatePrompt()
			{
				const title =
					prompt("input folder title");

				if (title != null)
				{
					await this.createVirtualFolder(title)
				}
			},

			showUploaderPopup()
			{
				this.chosenFiles = [];
				this.isShowUploaderPopup = true;
			},

			changeUploader(files)
			{
				this.chosenFiles = files;
			},

			getShortTitle(title)
			{
				if (title.length > 15)
				{
					return `${title.substring(0, 15)} ...`
				}

				return title;
			},

			getFileIcon(contentType)
			{
				const extention = fileExtensions.find((x) =>
				{
					return x.contentType == contentType
				});

				return extention ? extention.icon : "";
			},

			async selectFolder(virtualFolderId)
			{
				this.virtualFolderId = virtualFolderId;

				this.isLoading = true;
				await this.initFiles();
				this.isLoading = false;
			},

			async initFiles()
			{
				try
				{
					const payload = {
						strat: 0,
						length: 1000000,
						filter: {
							tagName: 'Asset.FileManager',
							virtualFolderId: this.virtualFolderId
						}
					}

					const service = new StaticFileService();
					const res = await service.managerList(payload, { HSR: false, HER: true });
					if (res.status == 200)
					{
						this.files = res.data.items || [];
					}
				} catch (e) { }
			},

			async initVirtualFolders()
			{
				try
				{
					const payload = {
						strat: 0,
						length: 1000000,
						order: {
							propertyName: "VirtualFolderId",
							desc: false,
						}
					}

					const service = new VirtualFolderService();
					const res = await service.list(payload, { HSR: false, HER: true });
					if (res.status == 200)
					{
						this.VirtualFolders = res.data.items || [];
					}

				} catch (e) { }
			},

			async createVirtualFolder(title)
			{
				try
				{
					const payload = {
						title: title,
						parentId: this.virtualFolderId
					}

					this.isLoading = true;
					const service = new VirtualFolderService();
					const res = await service.create(payload, { HSR: false, HER: true });
					if (res.status == 200)
					{
						await this.initVirtualFolders()
					}

				} catch (e) { }

				this.isLoading = false;
			},


			async deleteFolder(item)
			{
				const label =
					this.$loc.fromResource('message.deleteConfirm');

				if (confirm(label))
				{
					try
					{
						this.isLoading = true;
						const service = new VirtualFolderService();
						const res = await service.delete(item.virtualFolderId, { HSR: true, HER: true });
						if (res.status == 200)
						{
							await this.initVirtualFolders()
							await this.initFiles()
						}

					} catch (e) { }

					this.isLoading = false;
				}
			},


			async deleteFile(item)
			{
				const label =
					this.$loc.fromResource('message.deleteConfirm');

				if (confirm(label))
				{
					try
					{
						this.isLoading = true;
						const service = new StaticFileService();
						const res = await service.deleteById(item.staticFileId, { HSR: true, HER: true });
						if (res.status == 200)
						{
							await this.initFiles()
						}

					} catch (e) { console.log(e) }

					this.isLoading = false;
				}
			},

			async upload()
			{
				const files =
					this.chosenFiles;

				if (files.length > 0)
				{
					this.isLoading = true;
					this.isLoadingUpload = true;

					setTimeout(async () =>
					{
						for (var i = 0; i < files.length; i++)
						{
							try
							{
								const payload = {
									fileName: files[i].name,
									dataUrl: files[i].dataUrl,
									isPrivate: this.isPrivate,
									virtualFolderId: this.virtualFolderId,
									tagName: 'Asset.FileManager'
								}

								const service = new StaticFileService();
								const res = await service.upload(payload, { HSR: false, HER: true, useHttp: true });

							} catch (e) { console.log(e) }
						}

						this.isLoadingUpload = false;
						this.isShowUploaderPopup = false;

						await this.initFiles()

						this.isLoading = false;

					}, 50);
				}
			}


		}


	}
</script>
